import { render, staticRenderFns } from "./PostponeBooking.vue?vue&type=template&id=9dbbcc58&scoped=true"
import script from "./PostponeBooking.vue?vue&type=script&lang=js"
export * from "./PostponeBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dbbcc58",
  null
  
)

export default component.exports